import { render } from "./HuvSfvStatusReport.vue?vue&type=template&id=2b8085ea&ts=true"
import script from "./HuvSfvStatusReport.ts?vue&type=script&lang=ts&external"
export * from "./HuvSfvStatusReport.ts?vue&type=script&lang=ts&external"

import "./HuvSfvStatusReport.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__